import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { AppSettings } from './app/core/utils/app.settings';

// Declarar el tipo para window.DD_RUM
declare global {
  interface Window {
    DD_RUM?: {
      init: (config: any) => void;
    };
  }
}

bootstrapApplication(AppComponent, appConfig)
  .then(appRef => {
    // Inicializar Datadog RUM después de que la aplicación se haya bootstrapped
    if (window.DD_RUM) {
      const appSettings = appRef.injector.get(AppSettings);
      window.DD_RUM.init({
        clientToken: environment.datadog.clientToken,
        applicationId: environment.datadog.applicationId,
        site: environment.datadog.site,
        service: environment.datadog.service,
        env: environment.environmentName,
        sessionSampleRate: environment.datadog.sessionSampleRate,
        sessionReplaySampleRate: environment.datadog.sessionReplaySampleRate,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
        version: appSettings.app.version,
      });
    }
  })
  .catch(err => console.error(err));
